import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'LabelValue';

const classes = {
  container: `${PREFIX}-container`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.label}`]: {
    fontWeight: 300,
  },

  [`& .${classes.value}`]: {
    fontWeight: 500,
    wordBreak: 'break-word',
  },
}));

interface LabelValueProps {
  label: string;
  value: string | undefined;
  className?: string;
}

export default function LabelValue({
  label,
  value,
  className,
}: LabelValueProps) {
  return (
    <StyledBox component="div" className={className}>
      <Box component="div" className={classes.container}>
        <Typography component="div" className={classes.label}>
          {label}
        </Typography>
        <Typography component="div" className={classes.value}>
          {value}
        </Typography>
      </Box>
    </StyledBox>
  );
}
